// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.box-table {
  border-top: 0;
  border-radius: 0;
  box-shadow: none !important;
}

.box-table__header {
  color: #fff;
  background: #536584;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  padding: 8px !important;
}

.box-table__header-title, .box-header .box-table__header-title {
  line-height: 1.42857em;
  margin-top: 0 !important;
  font-size: 1.3em !important;
}

.box-table__tr {
  border-bottom: 1px solid #e0e0e0;
  border-left: 1px solid #e0e0e0;
  border-right: 1px solid #e0e0e0;
}

tbody .box-table__tr:hover {
  background: #f5f5f5;
}

.box-table__td {
  border-top: 0;
  border-right: 1px solid #eee;
  padding: 5px 7px;
  border-bottom: 0 !important;
}

.box-table__td:last-of-type {
  border-right: 0;
}
`, "",{"version":3,"sources":["webpack://./home/autoboss/ipfabric-product/services/frontend/app/containers/App/styles/box.css","webpack://./services/frontend/app/containers/App/styles/box.css"],"names":[],"mappings":"AADA;ECEE,aAAa;EACb,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,2BAA2B;EAC3B,4BAA4B;EAC5B,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;EACtB,wBAAwB;EACxB,2BAA2B;AAC7B;;AAEA;EACE,gCAAgC;EAChC,8BAA8B;EAC9B,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,4BAA4B;EAC5B,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,eAAe;AACjB","sourcesContent":[".box-table {\n  border-radius: 0;\n  border-top: 0;\n  box-shadow: none !important;\n}\n\n.box-table__header {\n  background: #536584;\n  border-top-left-radius: 8px;\n  border-top-right-radius: 8px;\n  color: #fff;\n  padding: 8px !important;\n}\n\n.box-table__header-title,\n.box-header .box-table__header-title {\n  font-size: 1.3em !important;\n  line-height: 1.42857143em;\n  margin-top: 0 !important;\n}\n\n.box-table__tr {\n  border-bottom: 1px solid #e0e0e0;\n  border-left: 1px solid #e0e0e0;\n  border-right: 1px solid #e0e0e0;\n}\n\ntbody .box-table__tr:hover {\n  background: #f5f5f5;\n}\n\n.box-table__td {\n  border-bottom: 0 !important;\n  border-right: 1px solid #eee;\n  border-top: 0;\n  padding: 5px 7px;\n}\n\n.box-table__td:last-of-type {\n    border-right: 0;\n  }\n",".box-table {\n  border-top: 0;\n  border-radius: 0;\n  box-shadow: none !important;\n}\n\n.box-table__header {\n  color: #fff;\n  background: #536584;\n  border-top-left-radius: 8px;\n  border-top-right-radius: 8px;\n  padding: 8px !important;\n}\n\n.box-table__header-title, .box-header .box-table__header-title {\n  line-height: 1.42857em;\n  margin-top: 0 !important;\n  font-size: 1.3em !important;\n}\n\n.box-table__tr {\n  border-bottom: 1px solid #e0e0e0;\n  border-left: 1px solid #e0e0e0;\n  border-right: 1px solid #e0e0e0;\n}\n\ntbody .box-table__tr:hover {\n  background: #f5f5f5;\n}\n\n.box-table__td {\n  border-top: 0;\n  border-right: 1px solid #eee;\n  padding: 5px 7px;\n  border-bottom: 0 !important;\n}\n\n.box-table__td:last-of-type {\n  border-right: 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
